// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FVig3","footer":"styles_footer__1yonq","passCodeTooltip":"styles_passCodeTooltip__3iA1q"};